// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueMaterial from "vue-material";

import microApp from '@micro-zoe/micro-app'

import App from './App'
import Icon from 'vue2-svg-icon/Icon.vue'
import kayak from '@/frame/kayak.js'
import global from '@/frame/global';
import '@/frame/utils.js';

import Chartist from "chartist";

import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/directives/dialog'
import store from '@/store'
import "vue-material/dist/vue-material.min.css";
import kayakPlugin from "@/frame/kayakPlugin.js"
import router from './router'
import './components/k-element/svg-icon/index'
import { checkSSO } from "@/utils/ssoHandle"
import Tools from "@/utils/tools"

// 主题引入, 放在样式最后引入进行覆盖
import "@/assets/scss/theme/index.scss";


Vue.use(VueQuillEditor);
Vue.use(ElementUI, {size: 'small'});
Vue.use(kayakPlugin);
Vue.use(router);

Vue.use(VueMaterial);



Vue.config.productionTip = false;
Vue.component('icon', Icon);
Vue.prototype.global=global;

Vue.prototype.$Chartist = Chartist;
Vue.prototype.Tools = Tools;


localStorage.setItem('origin', window.location.origin)

router.beforeEach((to, from, next) => {
  if(to.path.indexOf('/login') > -1) {
    // 前往登录界面
    checkSSO().then(res => {
      if(res && res.url) {
        window.location.href = res.url
      } else {
        next()
      }
    }).catch(() => {
      next()
    })
  } else {
    next()
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});

microApp.start()

// 微前端预加载
// microApp.preFetch([
//   { name: 'base', url: 'http://localhost:4001/#/' },
//   { name: 'flow', url: 'http://localhost:4002/#/' },
//   { name: 'hiring', url: 'http://localhost:4003/#/' },
// ])



// WEBPACK FOOTER //
// ./src/main.js